import { Factory } from 'miragejs';
import faker from 'faker';

export default {
  competition: Factory.extend({
    name: (i) => `${i} ${faker.lorem.sentences(1)}`,
  }),
};
